import { Controller } from "stimulus"
import { get, post } from '@rails/request.js'

export default class extends Controller {
  static targets = ["form", "input", "clearInput", "button", "searchResult"]
  static values = {
    purchaseSetId: Number,
  }

  connect() {
    // console.log('connected to purchaser controller')
    // console.log('this.formTarget', this.formTarget)
    // console.log('this.searchResultTarget', this.searchResultTarget)
    // console.log('this.inputTarget', this.inputTarget)
    // console.log('this.buttonTarget', this.buttonTarget)
  }

  async search(event) {
    console.log('search event', event)
    const response = await get(`/crush/users/search_by_phone_number?phone_number=${this.inputTarget.value}&purchase_set_id=${this.purchaseSetIdValue}`, {
      responseKind: 'json',
    })
    const body = await response.json
    // console.log('body', body)
    this.searchResultTarget.innerHTML = body.html
  }

  async addPurchaser(event) {
    console.log('addPurchaser event', event)
    const user_id = event.currentTarget.dataset.userId
    const purchase_set_id = event.currentTarget.dataset.purchaseSetId
    // console.log('user_id', user_id)
    // console.log('purchase_set_id', purchase_set_id)
    // {"amount"=> 60, "qty"=> 1, "purchase_sets"=> [{ "amount"=> 60, "qty"=> 1, "purchase_set_id"=> 3 }]}
    const order = {
      amount: 0, qty: 1, purchase_sets: [{ amount: 0, qty: 1, purchase_set_id: purchase_set_id }]
    }
    const response = await post(`/crush/purchase_set_orders/create_manually`, {
      body: JSON.stringify({ order, user_id }),
      responseKind: 'json',
    })
    const body = await response.json
    // console.log('body', body)
    this.searchResultTarget.innerHTML = body.html
  }

  close() {
    this.element.remove()
    window.location.reload()
  }

  clearInput(e) {
    this.inputTarget.value = ""
    this.clearInputTarget.classList.add('hidden')
    this.searchResultTarget.innerHTML = ""
    // this.buttonTarget.removeAttribute('disabled')
    // this.buttonTarget.textContent = "Search"
  }

  showClearInput(e) {
    if (this.inputTarget.value) {
      this.clearInputTarget.classList.remove('hidden')
    } else {
      this.clearInputTarget.classList.add('hidden')
    }
  }
}
